import { render, staticRenderFns } from "./DocumentosTable.vue?vue&type=template&id=812280e0&scoped=true"
import script from "./DocumentosTable.vue?vue&type=script&lang=ts"
export * from "./DocumentosTable.vue?vue&type=script&lang=ts"
import style0 from "./DocumentosTable.vue?vue&type=style&index=0&id=812280e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812280e0",
  null
  
)

export default component.exports